<template lang="html">
  <!-- roleID:1 = Admin, roleID:8 = External Operations -->
  <div class="row">
    <!-- roleID:1 = Admin -->
    <div
      v-if="PERMISSIONS.PROFILE[$store.getters.roleID].customerDetails"
      class="col-lg-6 lbv-contact-details"
    >
      <b-card header="Contact details">
        <div class="panel-body">
          <form
            id="device"
            @submit.prevent="checkForChanges"
          >
            <div class="form-row">
              <label
                for="FirstName-ID"
                class="col-lg-3 col-form-label"
              >First name</label>
              <div class="col-lg-9">
                <input
                  id="FirstName-ID"
                  v-model="deviceData.fname"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
            <div class="form-row">
              <label
                for="LastName-ID"
                class="col-lg-3 col-form-label"
              >Surname</label>
              <div class="col-lg-9">
                <input
                  id="LastName-ID"
                  v-model="deviceData.lname"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
            <div class="form-row">
              <label
                for="Address1-ID"
                class="col-lg-3 col-form-label"
              >Address Line 1</label>
              <div class="col-lg-9">
                <input
                  id="Address1-ID"
                  v-model="deviceData.address_1"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
            <div class="form-row">
              <label
                for="Address2-ID"
                class="col-lg-3 col-form-label"
              >Address Line 2</label>
              <div class="col-lg-9">
                <input
                  id="Address2-ID"
                  v-model="deviceData.address_2"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
            <div class="form-row">
              <label
                for="Address3-ID"
                class="col-lg-3 col-form-label"
              >Address Line 3</label>
              <div class="col-lg-9">
                <input
                  id="Address3-ID"
                  v-model="deviceData.address_3"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
            <div class="form-row">
              <label
                for="City-ID"
                class="col-lg-3 col-form-label"
              >City</label>
              <div class="col-lg-9">
                <input
                  id="City-ID"
                  v-model="deviceData.city"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
            <div class="form-row">
              <label
                for="Postcode-ID"
                class="col-lg-3 col-form-label"
              >Postcode</label>
              <div class="col-lg-9">
                <input
                  id="Postcode-ID"
                  v-model="deviceData.postcode"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
            <div class="form-row">
              <label
                for="Country-ID"
                class="col-lg-3 col-form-label"
              >Country</label>
              <div class="col-lg-9">
                <input
                  id="Country-ID"
                  v-model="deviceData.country"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
            <div class="form-row">
              <label
                for="Mobile-ID"
                class="col-lg-3 col-form-label"
              >Mobile number</label>
              <div class="col-lg-9">
                <b-form-input
                  id="Mobile-ID"
                  v-model="deviceData.mobile_number"
                  type="text"
                  class="form-control"
                  :state="mobilePhoneValid"
                />
              </div>
            </div>
            <div class="form-row">
              <label
                for="Telephone-ID"
                class="col-lg-3 col-form-label"
              >Home number</label>
              <div class="col-lg-9">
                <b-form-input
                  id="Telephone-ID"
                  v-model="deviceData.home_tel_number"
                  type="text"
                  class="form-control"
                  :state="homePhoneValid"
                />
              </div>
            </div>
            <div class="form-row">
              <label
                for="inputEmail"
                class="col-lg-3 col-form-label"
              >Email address</label>
              <div class="col-lg-9">
                <b-form-input
                  id="inputEmail"
                  v-model="deviceData.username"
                  type="text"
                  :state="emailValid"
                  class="form-control"
                />
              </div>
            </div>
            <div
              v-if="PERMISSIONS.PROFILE[$store.getters.roleID].vipInfo"
              class="vip-info form-row"
            >
              <label
                for="radios2"
                class="col-lg-3 col-form-label"
              >VIP customer</label>
              <b-form-radio-group
                id="radios2"
                v-model="deviceData.isVIP"
                name="radioSubComponent"
              >
                <b-form-radio value="1">
                  Yes
                </b-form-radio>
                <b-form-radio value="0">
                  No
                </b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="form-row action">
              <button
                id="ButtonAccountUpdate-ID"
                class="btn btn-primary"
                :disabled="!deviceHasChanges"
                type="submit"
              >
                Update
              </button>
            </div>
            <!-- errors -->
            <div
              v-if="updateSuccess"
              class="updateSuccess"
            >
              <span class="errorImg"><img
                src="static/img/error.svg"
                alt="login error"
              ></span>
              <span class="errLogin">{{ updateSuccess }}</span>
            </div>
            <div
              v-if="updateFailed"
              class="updateFailed"
            >
              <span class="errorImg"><img
                src="static/img/error.svg"
                alt="login error"
              ></span>
              <span class="errLogin">{{ updateFailed }}</span>
            </div>
          </form>
        </div>
        <!-- /.panel-body -->
      </b-card>
    </div><!--/.col-->
    <div
      v-if="PERMISSIONS.PROFILE[$store.getters.roleID].marketing"
      class="col-lg-6 lbv-contact-details"
    >
      <b-card header="Customer communications">
        <div class="panel-body">
          <form
            id="marketing"
            @submit.prevent="checkForChanges"
          >
            <div class="form-row">
              <h6>Marketing preferences</h6>
              <b-form-checkbox
                id="phoneAllowed"
                v-model="marketingPrefs.phoneAllowed"
                :plain="true"
                value="1"
                unchecked-value="0"
              >
                Phone
              </b-form-checkbox>
              <b-form-checkbox
                id="emailAllowed"
                v-model="marketingPrefs.emailAllowed"
                :plain="true"
                value="1"
                unchecked-value="0"
              >
                Email
              </b-form-checkbox>
              <b-form-checkbox
                id="smsAllowed"
                v-model="marketingPrefs.smsAllowed"
                :plain="true"
                value="1"
                unchecked-value="0"
              >
                SMS
              </b-form-checkbox>
              <b-form-checkbox
                id="postAllowed"
                v-model="marketingPrefs.postAllowed"
                :plain="true"
                value="1"
                unchecked-value="0"
              >
                Post
              </b-form-checkbox>
              <hr>
            </div>


            <div class="form-row action profile-info-update">
              <button
                id="ButtonMarketingUpdate-ID"
                class="btn btn-primary"
                :disabled="!marketingHasChanges"
                type="submit"
              >
                Update
              </button>
            </div>
            <!-- errors -->
            <div
              v-if="updateSuccess"
              class="updateSuccess"
            >
              <span class="errorImg"><img
                src="static/img/error.svg"
                alt="login error"
              ></span>
              <span class="errLogin">{{ updateSuccess }}</span>
            </div>
            <div
              v-if="updateFailed"
              class="updateFailed"
            >
              <span class="errorImg"><img
                src="static/img/error.svg"
                alt="login error"
              ></span>
              <span class="errLogin">{{ updateFailed }}</span>
            </div>
          </form>
        </div>
        <!-- /.panel-body -->
      </b-card>
    </div><!--/.col-->
  </div>
</template>

<script>
import deviceViewMixin from '../../mixins/deviceViewMixin'
import { PERMISSIONS } from '../../constants/permissions/permissions'
import { EventBus } from '../../event-bus.js'
import { TabNavEvent } from '../../events/tabNavEvent'
import { APIEvent } from '../../events/apiEvent'
import { StatusBarEvent } from '../../events/statusBarEvent'

export default {
  mixins: [deviceViewMixin],
  props: [
    // 'deviceData',
    // 'lb_id'
  ],
  data () {
    return {
      PERMISSIONS,
      updateFailed: null,
      updateSuccess: null,
      marketingPrefs: {},
      originalMarketing: {},
      originalDeviceData: {},
      marketingHasChanges: false,
      deviceHasChanges: false,
      ignoreInitialDeviceChange: true,
      ignoreInitialMarketingChange: true,
      addressProps: ['address_line1', 'address_line2', 'address_line3', 'postcode', 'city', 'country']
    }
  },
  computed: {
    emailValid () {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.deviceData.username) || this.ignoreInitialDeviceChange
    },
    mobilePhoneValid () {
      // min length for phone number is 8
      // https://stackoverflow.com/questions/14894899/what-is-the-minimum-length-of-a-valid-international-phone-number
      return this.ignoreInitialDeviceChange || this.deviceData.mobile_number.length > 8
    },
    homePhoneValid () {
      return this.ignoreInitialDeviceChange || this.deviceData.home_tel_number.length > 8 || this.deviceData.home_tel_number.length === 0
    }
  },
  watch: {
    deviceData: {
      handler (newVal, oldVal) {
        if (!this.ignoreInitialDeviceChange) {
          this.deviceHasChanges = true
          return
        }
        this.originalDeviceData = JSON.stringify(newVal)
        this.ignoreInitialDeviceChange = false
      },
      deep: true
    },
    marketingPrefs: {
      handler (newVal, oldVal) {
        // ignore the initial setting of the data
        if (!this.ignoreInitialMarketingChange) {
          this.marketingHasChanges = true
          return
        }
        this.originalMarketing = JSON.stringify(newVal)
        this.ignoreInitialMarketingChange = false
      },
      deep: true
    }
  },
  updated () {
    if (Object.keys(this.marketingPrefs).length === 0) {
      this.fetchMarketingPrefs()
    }
  },
  destroyed () {
    EventBus.$off(TabNavEvent.PROFILE)
  },
  methods: {
    fetchMarketingPrefs (data) {
      if (PERMISSIONS.PROFILE[this.$store.getters.roleID].marketing) {
        this.$store.dispatch(APIEvent.FETCH_ACCOUNT, this.deviceData.user_id)
          .then((response) => {
            this.marketingPrefs = response.data
          })
          .catch(this.handleError)
      }
    },
    determineChanges (obj1, obj2) {
      var changes = []
      for (var prop in obj1) {
        if (obj1.hasOwnProperty(prop) && obj2.hasOwnProperty(prop)) {
          if (!(obj1[prop] === obj2[prop])) {
            changes.push(prop)
          }
        }
      }
      return changes
    },
    checkForChanges (event) {
      let target = event.currentTarget.id
      if (target === 'device' &&
        !(this.homePhoneValid && this.mobilePhoneValid && this.emailValid)) {
        EventBus.$emit(StatusBarEvent.WARNING,
          'No update has been made. Please check validation errors.')
        return
      }
      var accountUpdates = {}
      var addressUpdates = {}
      var newVal = target === 'marketing' && PERMISSIONS.PROFILE[this.$store.getters.roleID].marketing
        ? this.marketingPrefs : this.deviceData
      var oldVal = target === 'marketing' && PERMISSIONS.PROFILE[this.$store.getters.roleID].marketing
        ? this.originalMarketing : this.originalDeviceData
      oldVal = JSON.parse(oldVal)
      var changes = this.determineChanges(newVal, oldVal)
      if (changes.length > 0) {
        for (var i = 0; i < changes.length; i++) {
          var prop = changes[i]
          var value = this.deviceData[prop] || this.marketingPrefs[prop]
          prop = this.getPropertyName(prop)
          if (this.addressProps.indexOf(prop) > -1) {
            if (prop === 'postcode') { prop = 'post_code' }
            // Only Address Line 2, Address Line 3 and Home Number can be empty
            if (value === undefined && (prop === 'address_line2' || prop === 'address_line3')) {
              value = ''
            }
            addressUpdates[prop] = value
            continue
          }
          if (this.deviceData.home_tel_number === '' && prop === 'home_tel_number') {
            value = ''
          }
          accountUpdates[prop] = value
        }
        if (Object.keys(accountUpdates).length > 0) {
          this.updateAccount(accountUpdates)
        }
        if (Object.keys(addressUpdates).length > 0) {
          this.updateAddress(addressUpdates)
        }
      } else {
        this.marketingHasChanges = false
        EventBus.$emit(StatusBarEvent.WARNING,
          'No update has been made since no changes were entered')
      }
    },
    getPropertyName (property) {
      // method to sanitise property names to account
      // for discrepancies in api property names
      var propsToChange = ['address_1', 'address_2', 'address_3', 'fname', 'lname']
      if (propsToChange.indexOf(property) > -1) {
        if (property.indexOf('address') > -1) {
          var bits = property.split('_')
          bits[1] = 'line' + bits[1]
          property = bits.join('_')
        } else {
          property = property === 'fname' ? 'first_name' : 'last_name'
        }
      }
      return property
    },
    updateAccount (update) {
      update.account_id = this.deviceData.user_id
      this.$store.dispatch(APIEvent.UPDATE_ACCOUNT, update)
        .then(() => {
          // success from api now update the original local store with the latest version
          this.originalMarketing = JSON.stringify(this.marketingPrefs)
          this.originalDeviceData = JSON.stringify(this.deviceData)
          this.marketingHasChanges = false
          this.deviceHasChanges = false
          EventBus.$emit(StatusBarEvent.SUCCESS, 'Your changes have been saved')
        })
        .catch(this.handleError)
      // vip has it's own API...
      if (update.hasOwnProperty('isVIP')) {
        let vipUpdate = {}
        vipUpdate.user_id = update.account_id
        vipUpdate.is_vip = update.isVIP
        this.$store.dispatch(APIEvent.UPDATE_VIP, vipUpdate)
          .then((res) => {
            EventBus.$emit(StatusBarEvent.SUCCESS, 'VIP status updated')
          })
      }
    },
    updateAddress (update) {
      update.LbDevice_ID = this.deviceData.lb_id
      this.$store.dispatch(APIEvent.UPDATE_ADDRESS, update)
        .then(() => {
          // success from api now update the original local store with the latest version
          this.originalDeviceData = JSON.stringify(this.deviceData)
          this.marketingHasChanges = false
          this.deviceHasChanges = false
          EventBus.$emit(StatusBarEvent.SUCCESS, 'Your changes have been saved')
        })
        .catch(this.handleError)
    },
    handleError (error) {
      var message = 'Your changes could not be saved. Please check and try again. :: '
      EventBus.$emit(StatusBarEvent.ERROR, message + error.message)
    }
  }
}
</script>

<style scoped>
  .vip-info #radios2{
    margin: 5px;
  }

  .form-control.is-valid {
    border-color: #c2cfd6;
  }

  #marketing h6 {
    margin-right: 10px;
  }

  .card {
   border-radius: 8px;
  }
  
 .card-header{
   background-color: #ccf4f1;
   border-top-left-radius: 8px;
   border-top-right-radius: 8px;
   border-bottom: none;
   font-weight: 600;
 }
</style>
